module.exports = __webpack_public_path__ + "static/media/Basal_6051.b9594263.jpg";